import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

export const Signup = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!API) return;
    setState("loading");
    try {
      await axios.post(`${API}/api/subscribe`, { email, source: "den-signup" });
      setState("done");
      toast.success("You're in the Den. Watch your inbox.");
    } catch {
      setState("idle");
      toast.error("That email didn't work. Try again?");
    }
  };

  return (
    <section id="join" data-testid="email-signup-section" className="relative bg-[#FFB21A] py-20 lg:py-28 overflow-hidden">
      <img src="/img/cherry.webp" alt="" className="absolute -right-10 -bottom-24 w-48 sm:w-72 rotate-[18deg] pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-8 items-end">
        <Reveal className="lg:col-span-7">
          <p className="eyebrow mb-4">Join the Den</p>
          <h2 className="font-display text-5xl sm:text-7xl leading-[0.92]">Be first to taste<br />what's next.</h2>
          <p className="mt-6 text-base sm:text-lg max-w-lg font-medium">New flavours, restock alerts and member-only deals, straight to your inbox. No spam, promise.</p>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          {state === "done" ? (
            <p data-testid="email-signup-success" className="font-display text-4xl">You're in. Welcome to the Den!</p>
          ) : (
            <form data-testid="email-signup-form" onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
              <input data-testid="email-input-field" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                className="w-full sm:flex-1 h-14 shrink-0 rounded-full bg-white text-[#1B1530] placeholder:text-[#4A4560] px-6 outline-none focus:ring-2 focus:ring-[#1B1530]" />
              <button data-testid="email-submit-button" disabled={state === "loading"}
                className="h-14 px-7 rounded-full bg-[#1B1530] text-white font-bold inline-flex items-center justify-center gap-2 hover:bg-[#FF5A5F] transition-colors">
                {state === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Join <ArrowRight className="h-4 w-4" /></>}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
};
